import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../homepage/components/Footer';

const CheckoutPortalWrapper = () => {
  const location = useLocation();
  const [iframeHeight, setIframeHeight] = React.useState('800px');

  const src = `/checkout-process/${location.search}`;

  React.useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.type === 'checkout-portal-resize' && event.data.height) {
        setIframeHeight(`${event.data.height}px`);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      
      <main className="flex-1 pt-16 flex flex-col">
        <div className="flex-1 w-full overflow-visible">
          <iframe
            src={src}
            className="w-full border-none"
            style={{ height: iframeHeight }}
            title="Checkout Process"
          ></iframe>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CheckoutPortalWrapper;